import { render } from "./GreetingPage.vue?vue&type=template&id=bf73febc&scoped=true"
import script from "./GreetingPage.vue?vue&type=script&lang=js"
export * from "./GreetingPage.vue?vue&type=script&lang=js"

import "./GreetingPage.vue?vue&type=style&index=0&id=bf73febc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf73febc"]])

export default __exports__